module.exports = __webpack_public_path__ + "static/media/recent_actors.731e8c9b.svg";